import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesStickyNotepad1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.43 25.905v1.53H32v-7.62h-1.52v6.09zm1.53-15.24h1.52v9.15h-1.52Zm-12.19 16.77h10.66v1.52H16.77Zm9.14-15.24h-1.52v10.66h-9.15v1.53h10.67zM6.1 30.475h10.67v-1.52H7.62v-3.05h7.62v-1.52H1.53v-7.62H0v9.14h6.1z\"/><path fill=\"currentColor\" d=\"M10.67 19.815h6.1v1.52h-6.1Zm0-3.05h9.14v1.52h-9.14Zm0-3.05h6.1v1.53h-6.1Zm0-3.05h9.14v1.53h-9.14Zm-6.09 6.1h3.04v3.05H4.58Zm0-6.1h3.04v3.05H4.58Z\"/><path fill=\"currentColor\" d=\"M3.05 4.575h4.57v3.05h10.67v-3.05h7.62v7.62h1.52v-1.53h1.53v-6.09h-1.53v-1.53h-9.14v-1.52H7.62v1.52H1.53v13.72h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesStickyNotepad1
